export function redirect(url: string) {
  try {
    if (window.top?.location?.href) {
      window.top.location.href = url;
    } else {
      window.location.href = url;
    }
  } catch (_err) {
    window.location.href = url;
  }
}

export function isInIframe() {
  return typeof window !== "undefined" && window.self !== window.top;
}
